import {
  CapaQuotationChatMessageRfq,
  CapaQuotationChatMessageType,
  CapaQuotationChatRoomStatus,
  CapaQuotationRfqReview,
  CapaQuotationRfqTransaction,
  CapaRfqStatus
} from '@generated/graphql';

import { SideMenuState } from '@modules/dashboard';

export const ClientOwnerMessageType = [
  CapaQuotationChatMessageType.AllowResponse,
  CapaQuotationChatMessageType.QuotationAdjustRequest,
  CapaQuotationChatMessageType.QuotationAgreement
];

export const CommonMessageType = [
  CapaQuotationChatMessageType.RfqComplete,
  CapaQuotationChatMessageType.RfqConfirm,
  CapaQuotationChatMessageType.RfqExpirationConfirm,
  CapaQuotationChatMessageType.QuitChatroomClient,
  CapaQuotationChatMessageType.QuitChatroomPartner,
  CapaQuotationChatMessageType.Withdraw
];

export const RfqMessageType = [
  CapaQuotationChatMessageType.IntroductionConsultingStart, //회사 소개서 상담시작
  //
  CapaQuotationChatMessageType.AllowResponse,
  CapaQuotationChatMessageType.RfqComplete,
  CapaQuotationChatMessageType.RfqConfirm,
  CapaQuotationChatMessageType.RfqExpirationConfirm,
  CapaQuotationChatMessageType.QuitChatroomClient,
  CapaQuotationChatMessageType.QuitChatroomPartner,
  CapaQuotationChatMessageType.AllowRequest,
  CapaQuotationChatMessageType.ConfirmRequest,
  CapaQuotationChatMessageType.CompleteRequest,
  CapaQuotationChatMessageType.Withdraw,
  // 견적서
  CapaQuotationChatMessageType.QuotationConsultingStart,
  CapaQuotationChatMessageType.QuotationAgreement,
  CapaQuotationChatMessageType.QuotationAdjustRequest,
  CapaQuotationChatMessageType.AdjustedQuotation,
  CapaQuotationChatMessageType.InduceQuotationRequest, //견적서 요청 유도
  CapaQuotationChatMessageType.RfqQuotationRegisterRequest, //견적서 발행 요청
  CapaQuotationChatMessageType.QuotationCreated,
  // 발주서
  CapaQuotationChatMessageType.PurchaseOrderCreated,
  CapaQuotationChatMessageType.AdjustedPurchaseOrder,
  CapaQuotationChatMessageType.PurchaseOrderAdjustRequest,
  CapaQuotationChatMessageType.PurchaseOrderAgreement,
  CapaQuotationChatMessageType.PurchaseOrderConsultingStart, // 발주서 도착
  CapaQuotationChatMessageType.PurchaseOrderRegisterRequest, //발주서 발행 요청
  CapaQuotationChatMessageType.InducePurchaseOrderIssue, // 발주서 발행유도
  CapaQuotationChatMessageType.RejectRfqPurchaseOrder, // 발주서 거부
  CapaQuotationChatMessageType.RequestRegisterTransactionReview,
  CapaQuotationChatMessageType.InduceRegisterTransactionReview,

  // 결제
  CapaQuotationChatMessageType.AwaitingPayment,
  CapaQuotationChatMessageType.ApprovedPayment,
  CapaQuotationChatMessageType.FailedPayment,
  CapaQuotationChatMessageType.CancelRequested,
  CapaQuotationChatMessageType.CancelConfirmed,
  CapaQuotationChatMessageType.RejectedPurchaseOrder,
  CapaQuotationChatMessageType.RefundRequested,
  CapaQuotationChatMessageType.RefundConfirmed,
  CapaQuotationChatMessageType.StartProcessing,
  CapaQuotationChatMessageType.StartShipping,
  CapaQuotationChatMessageType.InduceConfirmPurchase,
  CapaQuotationChatMessageType.DelayedConfirmPurchase,
  CapaQuotationChatMessageType.PurchaseConfirmed,
  CapaQuotationChatMessageType.SubmallRegistrationRequest
];

export const AnnotationMessageTypes = [
  CapaQuotationChatMessageType.QuotationAnnotationComment,
  CapaQuotationChatMessageType.QuotationAnnotationReComment
];

export const BypassMessageTypes = [
  CapaQuotationChatMessageType.BypassPrevention
];

export const QuotationMessgeTypes = [
  CapaQuotationChatMessageType.SimpleQuotation,
  CapaQuotationChatMessageType.DetailedQuotation
];

export const MessageMessageTypes = [
  CapaQuotationChatMessageType.Message,
  CapaQuotationChatMessageType.System,
  CapaQuotationChatMessageType.ChatStart
];
export const ApplicableToClientMessageTypes = [
  ...RfqMessageType,
  ...QuotationMessgeTypes,
  ...MessageMessageTypes,
  ...AnnotationMessageTypes,
  ...BypassMessageTypes
];
export const messageInputHeight = 142;
export const messageInputHeightMobile = 60;

export interface ChatRfqData {
  rfqStatus?: CapaRfqStatus;
  itpRewardExchange?: boolean;
  transaction?: CapaQuotationRfqTransaction;
  review?: CapaQuotationRfqReview;
  publicOpen?: boolean;
  hasQuotation: boolean;
  hasPurchaseOrder: boolean;
  isOldRfq: boolean;
  isConfirmedQuotation: boolean;
  refetchAll: () => void;
  isPcbDesign?: boolean;
}

export type ChatRoomInfo = {
  rfqId: string | undefined;
  partnerId: string | undefined;
  chatRoomId: string | undefined;
  roomStatus: CapaQuotationChatRoomStatus | undefined;
};

export interface EmailLinkQuery {
  sidemenu?: SideMenuState;
  quotationId?: string;
  partnerId?: string;
  rfqId?: string;
  chatRoomId?: string;
}

export const isClosedTypes = [
  CapaQuotationChatRoomStatus.ClosedBeforeConsulting,
  CapaQuotationChatRoomStatus.ClosedClient,
  CapaQuotationChatRoomStatus.ClosedConfirm,
  CapaQuotationChatRoomStatus.ClosedPartner
];

export interface CommomRfqBubbleProps {
  chatMessage?: CapaQuotationChatMessageRfq;
}

export const PROCESSING_PARTNER_ACTION_TYPE: (
  | CapaQuotationChatMessageType
  | undefined
)[] = [
  CapaQuotationChatMessageType.ApprovedPayment, // 파트너의 액션에 의한 타입은 아니지만, 제3자 웹훅에 의해 변경되는 값이므로 실시간 처리가 필요함.
  CapaQuotationChatMessageType.CancelConfirmed,
  CapaQuotationChatMessageType.RejectedPurchaseOrder,
  CapaQuotationChatMessageType.RefundConfirmed,
  CapaQuotationChatMessageType.StartProcessing,
  CapaQuotationChatMessageType.StartShipping
];
